import { on } from "@ngrx/store";
import { ApplicationStore } from "../../../application.state";
import { DataBrandsActions } from "./brands.actions";

// **************************************************************************
// BRANDS REDUCER
// **************************************************************************

const load = on(DataBrandsActions.load, (state: ApplicationStore) => ({
    ...state,
    data: {
        ...state.data,
        brand: {
            ...state.data.brand,
            brandsLoading: true,
        },
    },
}));

const loadSuccess = on(DataBrandsActions.loadSuccess, (state: ApplicationStore, { brands }) => ({
    ...state,
    data: {
        ...state.data,
        brand: {
            ...state.data.brand,
            brands,
            brandsLoading: false,
        },
    },
}));

const loadFailure = on(DataBrandsActions.loadFailure, (state: ApplicationStore, { error }) => ({
    ...state,
    data: {
        ...state.data,
        error,
        brand: {
            ...state.data.brand,
            brandsLoading: false,
        },
    },
}));

export const brandsReducer = [load, loadSuccess, loadFailure];
